<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item mt-4">
        <div class="date-grid">
          <div class="date-search-container">
            <div class="row p-1">
              <div class="col-md-2 form-group">
                <label for="distributor">Distributor</label>
                <select v-model="filters.distributor" id="distributor" class="search-input">
                  <option value="">All</option>
                  <option
                    v-for="dist in distributors"
                    :key="dist.profile_id"
                    :value="dist.profile_id"
                  >
                    {{ dist.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-2 form-group d-flex align-items-end">
                <button class="btn button-default" @click="search">Search</button>
              </div>
            </div>
            <div class="tiles-container mt-3">
              <div class="tile tile-sales">
                <h5>Total Normal Qty</h5>
                <p>{{ totalNormalQty }}</p>
              </div>

              <div class="tile tile-sales">
                <h5>Total Damaged Qty</h5>
                <p>{{ totalDamagedQty }}</p>
              </div>
              <div class="tile tile-loss">
                <h5>Total Volume</h5>
                <p>{{ formatVolume(totalVolume) }}</p>
              </div>
              <div class="tile tile-loss">
                <h5>Total Damaged Volume</h5>
                <p>{{ formatVolume(totalDamagedVolume) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-spinner mt-3">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div class="mt-4">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="border-bottom-primary">
                <th>Item</th>
                <th>Normal Qty</th>
                <th>Damaged Qty</th>
                <th>Volume (MT)</th>
                <th>Damaged Volume (MT)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in reportData" :key="item.item_name">
                <td>{{ item.item_name }}</td>
                <td>{{ item.normal_qty }}</td>
                <td>{{ item.damaged_qty }}</td>
                <td>{{ formatVolume(item.total_volume) }}</td>
                <td>{{ formatVolume(item.total_damaged_volume) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchdistributorstocks, fetchDistributorsList } from '@/services/dataService';

export default {
  data() {
    return {
      profile_id: localStorage.getItem('profile_id') || null,
      filters: {
        distributor: "",
      },
      distributors: [],
      reportData: [],
      loading: false,
      totalNormalQty: 0,
      totalDamagedQty: 0,
      totalVolume: 0,
      totalDamagedVolume: 0,
    };
  },
  created() {
    this.loadDistributors();
  },
  methods: {
    async loadDistributors() {
      try {
        const token = localStorage.getItem("token_set");
        const response = await fetchDistributorsList(this.profile_id, token);
        this.distributors = response.data.data;
      } catch (error) {
        console.error("Error fetching distributors:", error);
      }
    },
    async search() {
      this.loading = true;
      const params = {
        distributor_id: this.filters.distributor,
      };

      try {
        const token = localStorage.getItem("token_set");
        const response = await fetchdistributorstocks(params, token);
        this.reportData = response.data.data || [];

        // Calculate totalQty and totalVolume
        this.totalNormalQty = this.reportData.reduce((sum, item) => sum + parseFloat(item.normal_qty || 0),0);
        this.totalDamagedQty = this.reportData.reduce((sum, item) => sum + parseFloat(item.damaged_qty || 0),0);
        this.totalVolume = this.reportData.reduce((sum, item) => sum + parseFloat(item.total_volume || 0), 0);
         this.totalDamagedVolume = this.reportData.reduce((sum, item) => sum + parseFloat(item.total_damaged_volume || 0), 0);
      } catch (error) {
        console.error("Error fetching report:", error);
      } finally {
        this.loading = false;
      }
    },
    formatVolume(volume) {
      if (!volume) return "0.00";
      const mt = volume / 1000; // Convert kg to MT
      return mt.toFixed(2);
    },
  },
};
</script>
<style scoped>
/* Styling for labels */
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px; /* Adjust font size for better readability */
}

/* Styling for select elements */
select {
  width: 100%; /* Ensure select takes full width of its container */
  padding: 15px; /* Increase padding for better spacing */
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  text-align: left; /* Left align the text */
  transition: border-color 0.3s, box-shadow 0.3s;
}
/* Focus styling for select elements */
select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

/* Styling for search input */
.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px; /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* Focus styling for search input */
.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none; /* Remove the default outline */
}

/* Styling for search button */
.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px; /* Adjust font size for better readability */
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

/* Table styling */

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
}

.table td {
  background-color: #ffffff;
}

/* Popup styling */
.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  list-style: none;
  padding: 0;
}

.popup-content li {
  margin-bottom: 10px;
}

.popup-content hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

/* Optional: Add spacing and icon styling for the complaint messages */
.table td i {
  margin-right: 8px; /* Space between icon and text */
  color: red; /* Color of the flag icon */
}

/* Loading spinner styles */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff; /* Preserved color for spinner */
}

.remark-section label {
  font-weight: bold;
  font-size: 14px;
}

.remark-section textarea {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.remark-section textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.remark-section textarea {
  width: 100%;
  padding: 10px 20px; /* Add padding to the right and left */
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  padding-left: 20px;
}

.popup-content ul li {
  margin-bottom: 10px;
}


/* Tiles container */
.tiles-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
}

/* Tile styling */
.tile {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px; /* Reduced padding */
  text-align: center;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  flex: 1;
  margin: 0 5px; /* Reduced margin */
  max-width: 220px; /* Reduced max-width */
  position: relative;
  transition: transform 0.3s, box-shadow 0.3s;
}

.tile:hover {
  transform: translateY(-5px);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.tile h5 {
  margin: 0;
  font-size: 18px;
  color: #333;
  text-align: center; /* Center the text */
}

.tile-sales {
  background-color: #e0f7e0; /* Light green */
}

.tile-delivered {
  background-color: #cce5ff; /* Light blue */
}

.tile-loss {
  background-color: #ffcccc; /* Light red */
}
</style>